import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    linkActiveClass: 'is-active',
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
    routes: [
        {
            path: '/',
            meta: {
                auth: true
            },
            component: () => import('./components/MainLayout'),
            children: [
                {
                    path: '',
                    component: () => import('./views/Dashboard')
                },
                {
                    path: '/home',
                    name: 'Home',
                    component: () => import('./views/Dashboard')
                },
                {
                    path: '/calls',
                    component: () => import('./views/ivr/call/Index'),
                    name: 'calls',
                    meta: {
                        title: 'Llamadas'
                    }
                },
                {
                    path:'/admin',
                    name: 'Admin',
                    component: () => import('./components/Router'),
                    meta: {
                        auth: ['admin', 'super', 'root']
                    },
                    children: [
                        {
                            path:'users',
                            name:'users',
                            component: () => import('./views/user/Index'),
                            children: [
                                {
                                    path: '',
                                    component: () => import('./components/user/List'),
                                    name: 'User',
                                    meta: {
                                        title: 'Usuarios'
                                    }
                                },
                                {
                                    path: 'create',
                                    name: 'CreateUser',
                                    component: () => import('./components/user/Create'),
                                    meta: {
                                        title: 'Crear Usuario'
                                    }
                                },
                                {
                                    path: ':uuid',
                                    component: () => import('./components/user/Index'),
                                    children: [
                                        {
                                            path: '',
                                            component: () => import('./components/user/Show'),
                                            name: 'ShowUser',
                                            props: true,
                                            meta: {
                                                title: 'Usuario'
                                            }
                                        },
                                        {
                                            path: 'edit',
                                            component: () => import('./components/user/Edit'),
                                            name: 'EditUser',
                                            props: true,
                                            meta: {
                                                title: 'Editar Usuario'
                                            }
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'ivr',
                            component: () => import('./components/Router'),
                            children: [
                                {
                                    path: 'report',
                                    name: 'Report',
                                    component: () => import('./views/ivr/report/Index')
                                },
                                {
                                    path: 'providers',
                                    name: 'Providers',
                                    component: () => import('./views/ivr/provider/Index'),
                                    children: [
                                        {
                                            path: '',
                                            component: () => import('./components/ivr/provider/List'),
                                            name: 'Provider',
                                            meta: {
                                                title: 'Departamentos'
                                            }
                                        },
                                        {
                                            path: 'create',
                                            name: 'CreateProvider',
                                            component: () => import('./components/ivr/provider/Create'),
                                            meta: {
                                                title: 'Crear Departamento'
                                            }
                                        },
                                        {
                                            path: ':uuid',
                                            component: () => import('./components/Router'),
                                            meta: {
                                                title: 'Mostrar Departamento'
                                            },
                                            children: [
                                                {
                                                    path: '',
                                                    component: () => import('./components/ivr/provider/Show'),
                                                    props: true,
                                                    name: 'ShowProvider',
                                                    meta: {
                                                        title: 'Mostrar Departamento'
                                                    },
                                                },
                                                {
                                                    path: 'edit',
                                                    name: 'EditProvider',
                                                    component: () => import('./components/ivr/provider/Edit'),
                                                    props: true,
                                                    meta: {
                                                        title: 'Editar Departamento'
                                                    },
                                                }
                                            ]
                                        },
                                    ]
                                },
                                {
                                    path: 'worker',
                                    component: () =>  import('./views/ivr/worker/Index'),
                                    name: 'Workers',
                                    children: [
                                        {
                                            path: '',
                                            name: 'Worker',
                                            component: () => import('./components/ivr/worker/List'),
                                        },
                                        {
                                            path: ':uuid',
                                            component: () => import('./components/Router'),
                                            children: [
                                                {
                                                    name: 'ShowWorker',
                                                    path: '',
                                                    component: () => import('./components/ivr/worker/Show'),
                                                    props: true,
                                                },
                                                {
                                                    path: 'edit',
                                                    name: 'EditWorker',
                                                    component: () => import('./components/ivr/worker/Edit'),
                                                    props: true,
                                                }
                                            ]
                                        }

                                    ]
                                },
                                {
                                    path: 'poll',
                                    component: () => import('./views/ivr/poll/Index'),
                                    children: [
                                        {
                                            path: '',
                                            name: 'Polls',
                                            component: () => import('./components/ivr/poll/List'),
                                        },
                                        {
                                            path: ':uuid',
                                            name: 'ShowPoll',
                                            component: () => import('./components/Router'),
                                            children: [
                                                {
                                                    path: '',
                                                    component: () => import('./components/ivr/poll/Show'),
                                                    props: true,
                                                },
                                                {
                                                    path: 'edit',
                                                    component: () => import('./components/ivr/poll/Edit'),
                                                    props: true,
                                                },
                                            ]
                                        }
                                    ]
                                },
                                {
                                    path: 'question',
                                    component: () => import('./views/ivr/question/Index'),
                                    children: [
                                        {
                                            path: ':uuid',
                                            name: 'ShowQuestion',
                                            component: () => import('./components/Router'),
                                            children: [
                                                {
                                                    path: 'edit',
                                                    name: 'EditQuestion',
                                                    component: () => import('./components/ivr/question/Edit'),
                                                    props: true,
                                                }
                                            ]
                                        }, {
                                            path: 'create',
                                            name: 'CreateQuestion',
                                            component: () => import('./components/ivr/question/Create'),
                                        }
                                    ]
                                }
                            ]

                        },
                    ]
                },
                {
                    path: '/profile',
                    name: 'Profile',
                    component: () => import('./views/ivr/profile')
                }
            ]
        }, {
            path: '/login',
            name: 'Login',
            component: () => import('./views/auth/Login')
        }
        ,{
            path: '/password/email',
            name: 'ForgotPassword',
            component: () => import('./views/ForgotPassword')
        },
        {
            path: '/password/reset/:token',
            name: 'PasswordReset',
            props: true,
            component: () => import('./views/PasswordReset')
        },
        {
            path: '*',
            component: () => import('./components/partials/NotFound'),
            meta: {
                title: '404'
            }

        },
    ]
})
